<template>
	<el-row type="flex" justify="center" align="middle">
		<el-pagination
			@size-change="SizeChange"
			@current-change="CurrentChange"
			:current-page="pageInfo.pagenum"
			:page-size="pageInfo.pagesize"
			:page-sizes="pageSizes"
			:total="pageInfo.total"
			layout="total, sizes, prev, pager, next, jumper"
			background>
		</el-pagination>
	</el-row>
</template>

<script>
export default {
	name: "pagination",
	model: {
		prop: "pageInfo",
		event: "change",
	},
	props: {
		// 每页条数选择项
		pageSizes: {
			type: Array,
			default() {
				return [20,50, 100];
			},
		},
		// v-model绑定的数据对象
		pageInfo: {
			type: Object,
			reuqired: true,
		},
	},
	data() {
		return {};
	},
	methods: {
		SizeChange(newSize) {
			var newValue = {
				pagesize: newSize,
				pagenum: newSize <= this.total ? 1 : this.pageInfo["pagenum"],
			};
			this.$emit("change", Object.assign(this.pageInfo, newValue));
			this.$emit("pagination");
		},
		CurrentChange(newPage) {
			this.$emit("change", Object.assign(this.pageInfo, { pagenum: newPage }));
			this.$emit("pagination");
		},
	},
};
</script>
